import type { EnterpriseContact } from '@/shared/types/api.types'

export const BACKUP_ENTERPRISE_CONTACTS: EnterpriseContact[] = [
  {
    ContactType: 'phone',
    Region: 'qatar',
    Product: 'claims',
    ContactKey: 'phone_qatar_claims',
    Value: '8 000 742',
  },
  {
    ContactType: 'phonelink',
    Region: 'qatar',
    Product: 'claims',
    ContactKey: 'phonelink_qatar_claims',
    Value: 'tel:8000742',
  },
  {
    ContactType: 'wa',
    Region: 'qatar',
    Product: 'claims',
    ContactKey: 'wa_qatar_claims',
    Value: '50000742',
  },
  {
    ContactType: 'walink',
    Region: 'qatar',
    Product: 'claims',
    ContactKey: 'walink_qatar_claims',
    Value: 'https://api.whatsapp.com/send/?phone=97450000742&text&app_absent=0',
  },
  {
    ContactType: 'phone',
    Region: 'qatar',
    Product: 'general',
    ContactKey: 'phone_qatar_general',
    Value: '8 000 742',
  },
  {
    ContactType: 'phonelink',
    Region: 'qatar',
    Product: 'general',
    ContactKey: 'phonelink_qatar_general',
    Value: 'tel:8000742',
  },
  {
    ContactType: 'wa',
    Region: 'qatar',
    Product: 'general',
    ContactKey: 'wa_qatar_general',
    Value: '97450000742',
  },
  {
    ContactType: 'walink',
    Region: 'qatar',
    Product: 'general',
    ContactKey: 'walink_qatar_general',
    Value: 'https://api.whatsapp.com/send/?phone=97450000742&text&app_absent=0',
  },
  {
    ContactType: 'email',
    Region: 'qatar',
    Product: 'visitors',
    ContactKey: 'email_qatar_visitors',
    Value: 'info@qic.online',
  },
  {
    ContactType: 'wa',
    Region: 'qatar',
    Product: 'visitors',
    ContactKey: 'wa_qatar_visitors',
    Value: '97433524252',
  },
  {
    ContactType: 'walink',
    Region: 'qatar',
    Product: 'visitors',
    ContactKey: 'walink_qatar_visitors',
    Value: 'https://api.whatsapp.com/send/?phone=97433524252&text&app_absent=0',
  },
  {
    ContactType: 'qdlink',
    Region: 'qatar',
    Product: 'visitors',
    ContactKey: 'qdlink_qatar_visitors',
    Value: 'https://v536.adj.st/?adj_t=1fkoogsb',
  },
]
